import { Tag } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

const statusContent = {
    disabled: {
        textKey: TextKey.Inactive,
        variant: 'basicBold' as const,
    },
    enabled: {
        textKey: TextKey.Active,
        variant: 'success' as const,
    },
};

export function StatusTag({ isEnabled }: { isEnabled?: boolean | null }) {
    const content = isEnabled ? statusContent.enabled : statusContent.disabled;

    return (
        <Tag variant={content.variant}>
            <LocalizedText textKey={content.textKey} />
        </Tag>
    );
}
